import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-employee-pateint-menu',
  templateUrl: './employee-pateint-menu.component.html',
  styleUrls: ['./employee-pateint-menu.component.css']
})
export class EmployeePatientMenuComponent implements OnInit {

  isEmp:boolean=false;
  constructor(public global: Globals) {


  }

  ngOnInit() {
  
  }

}
